"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVerification = void 0;
const react_1 = require("react");
const verification_1 = require("../../shared/verification");
const useVerification = (_a = {}) => {
    var { publicKey, disableRecryption } = _a, params = __rest(_a, ["publicKey", "disableRecryption"]);
    const [keysData, setKeysData] = (0, react_1.useState)();
    const ensureKeysData = () => __awaiter(void 0, void 0, void 0, function* () {
        const _keysData = keysData !== null && keysData !== void 0 ? keysData : (yield (0, verification_1.getVerificationKeysData)(publicKey, params));
        if (_keysData && !keysData) {
            setKeysData(_keysData);
        }
        return _keysData;
    });
    const prepareVerification = (requestPath, requestOptions) => __awaiter(void 0, void 0, void 0, function* () {
        const _keysData = yield ensureKeysData();
        const _prepareVerification = (0, verification_1.prepareVerificationRequest)({ disableRecryption, keysData: _keysData });
        return _prepareVerification(requestPath, requestOptions);
    });
    const processResponse = (encryptedResponse, derivedSecretKey) => __awaiter(void 0, void 0, void 0, function* () {
        const _keysData = yield ensureKeysData();
        const _processResponse = (0, verification_1.processVerificationResponse)({ disableRecryption, keysData: _keysData });
        return _processResponse(encryptedResponse, derivedSecretKey);
    });
    return {
        prepareVerification,
        processResponse,
    };
};
exports.useVerification = useVerification;
//# sourceMappingURL=useVerification.js.map